import { render } from "./WarrantyRepairButton.vue?vue&type=template&id=38d59528"
import script from "./WarrantyRepairButton.vue?vue&type=script&lang=js"
export * from "./WarrantyRepairButton.vue?vue&type=script&lang=js"

import "./WarrantyRepairButton.vue?vue&type=style&index=0&id=38d59528&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__